module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "124568189198"
    }
  }, [_c('span', {
    staticClass: "titulo-texto"
  }, [_vm._v(_vm._s(_vm.titulo) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "valor-texto"
  }, [_vm._v(_vm._s(_vm.valor))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24eba5d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RelatorioTextoDestaque.vue
// module id = 1880
// module chunks = 1